import { myLocationQueryOptions } from "@/api/me";
import { queryClient } from "@/api/utils";
import { getIsTopUpEnabled } from "@/utils/topup";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { fallback, object, optional, string } from "valibot";

export const Route = createFileRoute("/_auth/_app/top-up")({
  validateSearch: object({
    "return-to": fallback(optional(string()), undefined),
  }),
  beforeLoad: async () => {
    const location = await queryClient.ensureQueryData(myLocationQueryOptions);
    const enabled = getIsTopUpEnabled({
      countryCode: location?.country_code,
    });
    if (!enabled) {
      throw redirect({
        to: "/marketplace",
      });
    }
  },
});
